import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListWarehouses(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getWarehouseDetail(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    createOrUpdateWarehouse(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
})()